// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .main-content {
    width: 100%;
    min-height: calc(100vh - [navbar-height] - [footer-height]); 
    display: flex;
    flex-direction: column;
} */
 `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;GAKG","sourcesContent":["/* .main-content {\r\n    width: 100%;\r\n    min-height: calc(100vh - [navbar-height] - [footer-height]); \r\n    display: flex;\r\n    flex-direction: column;\r\n} */\r\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
